const getRootElementFontSize = () => {
  return parseFloat(
    getComputedStyle(
      document.documentElement
    ).fontSize
  );
};

export const remToPx = (value) => value * getRootElementFontSize();